import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import ComposeViewState from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';
import setIsDarkMode from 'owa-mail-compose-store/lib/actions/setIsDarkMode';

const styles = require('./ComposeEditorToggle.scss');
const classNames = require('classnames/bind').bind(styles);

export interface ComposeDarkModeToggleProps {
    viewState: ComposeViewState;
}

// Similar to Editor Downgrade, this will likely never be pushed beyond SDF, as this is temporary for debugging.
const tooltipText =
    'An SDF-only debugging for swtiching between light and dark mode. ' +
    'If you want to verify your message content prior to send, switch the toggle.';

@observer
export class ComposeDarkModeToggle extends React.Component<ComposeDarkModeToggleProps> {
    private onToggleChange = (event: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        setIsDarkMode(this.props.viewState, checked);
    };

    render() {
        const { isDarkMode, bodyType } = this.props.viewState;
        let disabled = bodyType !== 'HTML';
        return (
            <div className={styles.preferredEditorToggle}>
                <TooltipHost content={tooltipText}>
                    <Icon className={styles.tooltipIcon} iconName={ControlIcons.Info} />
                </TooltipHost>
                <span
                    className={classNames({
                        toggleSymbol: true,
                        active: !isDarkMode,
                    })}>
                    🌤️
                </span>
                <Toggle
                    className={styles.toggle}
                    disabled={disabled}
                    defaultChecked={isDarkMode}
                    onChange={this.onToggleChange}
                />
                <span
                    className={classNames({
                        toggleSymbol: true,
                        active: isDarkMode,
                    })}>
                    🌙
                </span>
            </div>
        );
    }
}

export default ComposeDarkModeToggle;
